import {
    SET_ACTION_BUTTON_PROPERTIES,
    ACTION_BUTTON_OPEN_MODAL,
    ACTION_BUTTON_CLOSE_MODAL,
} from 'common/actions/actionButtonActions';

export function actionButtonPropertyReducer(state, action){
    if(!action || action.type !== SET_ACTION_BUTTON_PROPERTIES){
        return state;
    }
    
    const properties = action.payload;    

    return {
        ...state,
        app: {
            ...state.app,
            actionButton: properties
        }
    };
}

export function actionButtonToggleModal(state, action) {
    if (!action) {
        return state;
    }

    if (action.type !== ACTION_BUTTON_OPEN_MODAL
        && action.type !== ACTION_BUTTON_CLOSE_MODAL) {
        return state;
    }

    const modalName = action.payload;
    const modalKey = `${modalName}Open`;
    const shouldOpenModal = action.type === ACTION_BUTTON_OPEN_MODAL;

    return {
        ...state,
        app: {
            ...state.app,
            actionButton: {
                ...state.app.actionButton,
                [modalKey]: shouldOpenModal,
            }
        }
    };
}
